<div class="image image__wrapper">
  <div *ngIf="isLoading" class="image__loader">
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" />
    </svg>
  </div>

  <img
    class="img"
    [src]="src || imageNotAvailable"
    alt="{{
      alt || src
        ? 'Image description wording on grey background'
        : 'Image not available wording on grey background'
    }}"
    (load)="hideLoader()"
    (error)="error()"
    (swipeleft)="fn()"
    (swiperight)="fn()"
  />
</div>
